import get from 'lodash.get';

const getColorPalettes = (state) => get(state, 'ws.template.meta.customization.colorPalettes', []);

export default getColorPalettes;
